// Utils
import { sendAmplitudeEvent } from '../../../analytics/amplitudeService';

// Constants
import {
    AMPLITUDE_USER_PROPS,
    ANALYTICS_ZOOM_TYPES,
    TRACKED_FEATURES,
} from '../../../../common/analytics/statsConstants';
import localStorageService from '../../../utils/services/localStorage/localStorage';

const ZOOM_ANALYTICS_THROTTLE_KEY = 'milanote.amplitude_limit.zoom';

/**
 * Sends an amplitude event for zoom if the zoom changes from zoomed in to zoomed out or resetting zoom.
 */
export const sendAmplitudeZoomEvent = (prevZoomScale: number, nextZoomScale: number) => {
    // We should only send a zoom event when zoom changes between the states (zoomed in, zoomed out or reset to 100%)
    const shouldSendAmplitudeEvent =
        // If the zooms are the same, don't send an event
        prevZoomScale !== nextZoomScale &&
        // If the zoom was zoomed out or at 100% but now is greater than 100%, send an event
        ((prevZoomScale <= 1 && nextZoomScale > 1) ||
            // If the zoom was zoomed in or at 100% but now is less than 100%, send an event
            (prevZoomScale >= 1 && nextZoomScale < 1) ||
            // If we're resetting to 100% then send an event
            nextZoomScale === 1);

    if (!shouldSendAmplitudeEvent) return;

    const lastZoomAnalyticsEventTimestamp = localStorageService.getItem(ZOOM_ANALYTICS_THROTTLE_KEY);

    // If we've sent any zoom analytics event on this device, don't worry about sending it again
    if (lastZoomAnalyticsEventTimestamp) return;

    let analyticsZoomType = ANALYTICS_ZOOM_TYPES.RESET_ZOOM;

    if (nextZoomScale > 1) {
        analyticsZoomType = ANALYTICS_ZOOM_TYPES.ZOOM_IN;
    } else if (nextZoomScale < 1) {
        analyticsZoomType = ANALYTICS_ZOOM_TYPES.ZOOM_OUT;
    }

    sendAmplitudeEvent({
        eventType: 'Zoom changed',
        eventProperties: {
            zoomType: analyticsZoomType,
        },
        userProperties: {
            [AMPLITUDE_USER_PROPS.FEATURE]: { [TRACKED_FEATURES.ZOOM]: true },
        },
    });

    localStorageService.setItem(ZOOM_ANALYTICS_THROTTLE_KEY, Date.now().toString());
};
